import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RiDeleteBin4Line } from "react-icons/ri";
import { MdEdit } from "react-icons/md";
import { FaPlus } from "react-icons/fa6";
import { Link, useNavigate, useParams } from "react-router-dom";

import api from "@/services/api";
import toast from "react-hot-toast";
import Loader from "@/components/Loader";
import Modal from "@/components/Modal";
import ShareholderModal from "./components/ShareholderModal";

const FinanceShareholder = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams();
  const [values, setValues] = useState();
  const [questions, setQuestions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [elementIndex, setElementIndex] = useState({});

  useEffect(() => {
    fetchQuestions();
    fetchData();
  }, [id]);

  const fetchQuestions = async () => {
    try {
      const res = await api.post("/question/search", { limit: 300, startup: true });
      if (res.ok) {
        setQuestions(res.data);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const fetchData = async () => {
    try {
      const res = await api.get(`/company/${id}`);
      if (res.ok) {
        if (!res.data.plan) res.data.plan = "certified";
        setValues(res.data);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleChange = async () => {
    try {
      const res = await api.put(`/company/${id}`, values);
      if (!res.ok) throw new Error("Une erreur s'est produite lors de la mise à jour de la valeur");
      toast.success("Valeur mise à jour avec succès");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleNext = async () => {
    await handleChange();
    navigate(`../form-finance-funding`);
  };

  const handleEdit = async (v) => {
    setValues((prev) => ({
      ...prev,
      shareholders: prev.shareholders.map((shareholder, i) => (i === elementIndex ? v : shareholder)),
    }));
    setIsOpen(true);
  };

  const handleDelete = async (l, index) => {
    setValues((prev) => ({
      ...prev,
      shareholders: prev.shareholders.filter((_, i) => i !== index),
    }));
  };

  const handleAdd = async () => {
    const newShareholder = { leader: "" };
    setValues((prev) => ({
      ...prev,
      shareholders: [...prev.shareholders, newShareholder],
    }));
    setElementIndex(values.shareholders.length);
    setIsOpen(true);
  };

  if (!values) return <Loader />;

  return (
    <div className="w-full space-y-8 px-40">
      <div>
        <label className="block text-gray-700 text-sm font-bold mb-2">
          {t("lable.how_many_shareholders")}
          <span className="ml-2 text-red-500">*</span>
        </label>
        <input
          className="input"
          placeholder={t("placeholder_enter")}
          value={values?.shareholders_count}
          onChange={(e) => setValues((prev) => ({ ...prev, shareholders_count: e.target.value }))}
        />
      </div>

      <div>
        <p className="text-lg mb-5 font-semibold">{t("lable.list_of_main_shareholders")}</p>
        <label className="block text-gray-700 text-sm font-bold mb-2">{t("lable.name_of_shareholder")}</label>

        <div className="flex flex-col gap-2">
          {values?.shareholders.length !== 0 &&
            values?.shareholders?.map((sh, index) => (
              <div
                key={index}
                className="appearance-none py-1  focus:outline-2 focus:outline-gray-200 border rounded-md w-full px-3 text-gray-700 leading-tight flex justify-between items-center"
              >
                <p>{sh?.name_of_shareholder}</p>
                <div className="flex gap-2">
                  <button
                    onClick={() => {
                      setElementIndex(index);
                      setIsOpen(true);
                    }}
                  >
                    <MdEdit className="w-10 p-2 h-10 border rounded-md flex justify-center items-center cursor-pointer hover:bg-gray-50" />
                  </button>
                  <button onClick={() => handleDelete(sh, index)}>
                    <RiDeleteBin4Line className="w-10 p-2 h-10 border rounded-md flex justify-center items-center  cursor-pointer hover:bg-gray-50" />
                  </button>
                </div>
              </div>
            ))}

          <button className="w-full bg-gray-200 hover:bg-gray-300 py-2 flex mt-5 justify-center items-center gap-3 rounded" onClick={() => handleAdd()}>
            Ajouter
            <FaPlus />
          </button>

          <Modal
            show={isOpen}
            onClose={() => {
              setIsOpen(false);
              setElementIndex(null);
            }}
          >
            <ShareholderModal setOpen={setIsOpen} shareholder={values?.shareholders[elementIndex]} setShareholder={(v) => handleEdit(v)} questions={questions} />
          </Modal>
        </div>
      </div>

      <div className="flex justify-between w-full">
        <Link to={`../form-finance-situation`} className="empty-button disabled:hover:bg-white px-10">
          {t("previous")}
        </Link>
        <div className="flex items-center gap-2">
          <button className="empty-button disabled:hover:bg-white px-10" onClick={handleChange}>
            {t("save")}
          </button>
          <button className="primary-button disabled:hover:bg-white px-10" onClick={handleNext}>
            {t("next")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FinanceShareholder;
